import { QueryClient, useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { JobImprovedViewModel, toJobImprovedViewModel } from '../models';
import { jobClient } from './client';

export const useGetJobImproved = (jobId: number) => {
  return useQuery<JobImprovedViewModel>({
    queryKey: [QueryKey.useGetJobImproved, jobId],
    queryFn: async () => {
      const { data: response } = await jobClient.getJobImproved(jobId);

      return toJobImprovedViewModel(response);
    },
  });
};

useGetJobImproved.fetchOrCache = async (queryClient: QueryClient, jobId: number): Promise<JobImprovedViewModel> => {
  const cache = queryClient.getQueryData<JobImprovedViewModel>([QueryKey.useGetJobImproved, jobId]);
  if (cache) return cache;

  const { data: response } = await jobClient.getJobImproved(jobId);
  const viewModel = toJobImprovedViewModel(response);

  queryClient.setQueryData([QueryKey.useGetJobImproved, jobId], viewModel);

  return viewModel;
};
